import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import TextArea from '../../common/Fields/TextArea';
import { REFERRAL } from '../../../constants';
import Button from '../../common/Fields/Button';

class AddOpportunityNote extends React.Component {
  static propTypes = {
    getNoteValue: PropTypes.func.isRequired,
    saveStatus: PropTypes.func.isRequired,
    cancelStatus: PropTypes.func.isRequired,
    hideModal: PropTypes.func,
    show: PropTypes.bool,
    size: PropTypes.number,
    title: PropTypes.string
  }

  state = {
    value: '',
    isWarning: false
  };

  onChangeHandler = (event) => {
    const { value } = event.target;
    this.setState({ value, isWarning: false });
    this.props.getNoteValue(value);
  }

  onClickSave = () => {
    const { value } = this.state;
    if (value) {
      this.props.saveStatus();
    } else {
      this.setState({ isWarning: true });
    }
  }

  onClickCancel = () => {
    this.props.cancelStatus();
  }

  render () {
    const { show, size = 5, title = '', hideModal } = this.props;
    const { isWarning } = this.state;
    const styleVal = { border: '1px solid #ccc', width: '100%', padding: '0.5rem 0.5rem' };
    return (
      <Modal centered show={show} onHide={hideModal} autoFocus size={size} dialogClassName='addnotes-modal oppt-note-modal'>
        {
          title && <Modal.Header>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
        }
        <Modal.Body>
          <div>
            <TextArea onChangeHandler={this.onChangeHandler} rows={5} placeHolder={'Please enter the note.'} styleVal={styleVal} classVal={'hide-scroll-y opp-status-notes-text opp-note-textarea-field'} />
            { isWarning &&
            <div className={'alert-message'}>* Notes are required below</div>
            }
            <div className='row pt-3'>
              <div className='col-6'>
                <Button onClickHandler={this.onClickCancel} name={'Cancel'} classVal={'btn btn-outline-primary btn-block'} styleVal={{ border: '1px solid grey' }} />
              </div>
              <div className='col-6'>
                <Button onClickHandler={this.onClickSave} name={'Save'} classVal={'btn btn-primary btn-block'} />
              </div>
            </div>
            <div className='note-disclaimer'><span className='red-asterisk'>*</span> {REFERRAL.NOTE_DISCLAMIER}</div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default AddOpportunityNote;
